import { defineStore } from "pinia";
import { ref, computed } from "vue";

const CURRENT_USER_STORAGE_KEY = "current-user";

export const useUsersStore = defineStore("users", () => {
  // state
  const currentUser = ref(null);
  const usersListLimit = ref(null);
  const usersListOffset = ref(null);

  if (localStorage.getItem(CURRENT_USER_STORAGE_KEY)) {
    const currentUserJSON = localStorage.getItem(CURRENT_USER_STORAGE_KEY);
    currentUser.value = JSON.parse(currentUserJSON);
  }

  // getters
  const getCurrentUser = computed(() => currentUser.value);

  // actions
  function setCurrentUser(user = null) {
    currentUser.value = user;
    if (user === null) {
      localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
    } else {
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(user));
    }
  }

  function setUsersListLimit(limit) {
    if (limit === usersListLimit.value) return;
    usersListLimit.value = limit;
  }

  function setUsersListOffset(offset) {
    if (offset === usersListOffset.value) return;
    usersListOffset.value = offset;
  }

  return {
    // state
    currentUser,
    usersListLimit,
    usersListOffset,

    // getters
    getCurrentUser,

    // actions
    setCurrentUser,
    setUsersListLimit,
    setUsersListOffset,
  };
});
